import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export interface TechnologistOrderPrefill {
    documentType: string | null;
    technologistName: string | null;
}

export default class TechnologistOrderPrefillAPI {
    public static async get(projectId: string): Promise<TechnologistOrderPrefill> {
        let response;
        try {
            response = (await ApiController.get(ApiRoutes.technologist.prefill(projectId))) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return response?.data ?? { documentType: null, technologistName: null };
    }
}